module.exports = __webpack_public_path__ + "static/img/2_02.02522129.jpg";